import { useTranslation } from 'react-i18next';
import { Header, ReleaseContainer, StyledHeaderContainer } from './styled';
import { useGetIsUpsellInfoShown } from './hooks';
import { UpsellInfo } from './components/UpsellInfo';
import { ReleasesContent } from './components/ReleasesContent';

const Releases = () => {
  const { t } = useTranslation();

  const isUpsellInfoShown = useGetIsUpsellInfoShown();

  return (
    <>
      <ReleaseContainer>
        <StyledHeaderContainer>
          <Header data-testid="header" variant="h1">
            {t('account:sideBar:releases')}
          </Header>
        </StyledHeaderContainer>

        {isUpsellInfoShown ? <UpsellInfo /> : <ReleasesContent />}
      </ReleaseContainer>
    </>
  );
};

export default Releases;
